module.exports = __webpack_public_path__ + "img/face005.c3b35763.jpg";